import { useState } from "react";

const faqs = [
  {
    q: "吃瓜神器去水印会损伤画质吗？",
    a: "去水印默认可选原画档保存，选择原画后再做本地压缩，画质损失会更小，细节更经得起回放与二次剪辑。片源本身是低清的话，去水印也无法凭空提升清晰度。",
  },
  {
    q: "解析出的链接多久有效？需要登录吗？",
    a: "解析出的可播地址与来源平台有效期一致，高峰期通道可能排队，稍后重试即可。本站为玩法指南页，仅作功能演示，不需要登录、不接收任何提交。",
  },
  {
    q: "倍速播放会不会漏掉弹幕名场面？",
    a: "倍速的同时建议配合弹幕聚合的「高能标记」，当弹幕出现明显峰值时会有标识提示，必要时切回原速或使用片段循环精看，重点基本不会错过。",
  },
  {
    q: "直播录屏怎么避免漏录或中断？",
    a: "建议开启「直播跟随 + 后台录制」，断流会自动续录并按时间点自动分段，文件名自带时间戳。录制前关闭系统无关通知，也能避免弹窗声音混进成片。",
  },
  {
    q: "弹幕聚合的两端时间轴对不上怎么办？",
    a: "先确认两个片段的起点一致再对齐，差几秒都会让名场面错位。若仍偏位，可手动微调偏移量，把两边弹幕拉回到同一时间轴。",
  },
  {
    q: "一次想处理很多条素材，有没有批量玩法？",
    a: "可以先集中「解析」把零散分享链接统一转成可播地址归档，再按题材归入「聚合」合集，需要精剪的片段再用去水印原画保存，整体效率更高。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
            玩转吃瓜神器前，先看这几个 Q&A
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            围绕去水印、解析、倍速、录屏、弹幕、聚合的常见疑问，按点展开即可。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-2xl border bg-background-50 transition-colors ${
                  isOpen ? "border-accent-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left md:px-5"
                >
                  <span className="flex items-start gap-2.5 text-sm font-bold text-foreground-950 md:text-base">
                    <span
                      className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${
                        isOpen
                          ? "bg-accent-500 text-background-50"
                          : "bg-secondary-100 text-foreground-600"
                      }`}
                    >
                      {isOpen ? <i className="ri-close-line" /> : "?"}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform ${
                      isOpen ? "rotate-180 text-accent-600" : ""
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-4 pl-11 text-sm leading-relaxed text-foreground-600 md:pl-12">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}